import { render } from "./localization-setting.vue?vue&type=template&id=10868836"
import script from "./localization-setting.vue?vue&type=script&lang=js"
export * from "./localization-setting.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__